<template>
  <div class="fulfillment-reasons">
    <h3 class="title">
      Reason
    </h3>
    <ul class="reasons-list">
      <li class="reason-item">
        {{ reason }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "FulfillmentReasons",
  props: {
    reason: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.fulfillment-reasons {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  max-width: 500px;
  font-family: sans-serif;

  .title {
    color: #333;
    font-size: 1.1em;
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  .reasons-list {
    margin: 0;
    padding: 0;
    list-style: none;

    .reason-item {
      position: relative;
      padding: 8px 0 8px 24px;
      color: #555;
      line-height: 1.4;
      word-break: break-word;

      &:before {
        content: "•";
        position: absolute;
        left: 8px;
        color: #999;
      }
    }
  }
}
</style>
